module.exports = __webpack_public_path__ + "images/ImpactBoard.png";


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/scoring/ImpactBoard.png
// module id = 714
// module chunks = 0